import Link from 'next/link'
import { StructuredText } from 'react-datocms'
import styled from 'styled-components'
import { SciencePageStudyRecord } from 'types'

const StyledScienceStudyBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  border: 1px solid ${(props) => props.theme.v2.onSurface.subdued.border};
  border-radius: 16px;

  h3 {
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueRegular};
    margin-bottom: 16px;
    margin-top: 0;

    a {
      p {
        font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
        line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
        font-family: ${(p) => p.theme.v2.font.lotaGrotesqueRegular};
        margin-top: 0;
      }
    }
  }

  div {
    > p {
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
      font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
      color: ${(props) => props.theme.v2.onSurface.subduedText};
      margin-bottom: 0;
    }
  }
`

export const SciencePageStudyBlock = ({ record }: { record: SciencePageStudyRecord }) => {
  return (
    <StyledScienceStudyBlock id={record.id}>
      <div>
        <h3>
          <Link href={record.studyLink} target="_blank" passHref>
            <StructuredText data={record.journalName} />
          </Link>
        </h3>

        <StructuredText data={record.summary} />
      </div>

      <div>
        <p>
          <i>{record.publishDate}</i>
        </p>
      </div>
    </StyledScienceStudyBlock>
  )
}
